import * as React from 'react';
import { useEffect } from 'react';
import Input from '../input/Input';
interface CurrecyInputProps {
  name: string;
  value: number;
  setValue: (newValue: number) => void;
  setValid: (valid: boolean) => void;
  currencySign: string;
  minValue?: number;
}
export const CurrencyInput: React.FC<CurrecyInputProps> = ({
  name,
  value,
  setValue,
  setValid,
  currencySign,
  minValue,
}) => {
  const formatValue = (val: number) => `${currencySign} ${val > 0 ? val.toFixed(2) : '0.00'}`;

  const [valueString, setValueString] = React.useState<string>(formatValue(value));

  useEffect(() => {
    setValueString(formatValue(value));
  }, [currencySign, value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const targetValue = e.target.value;
    const escapedCurrencySign = currencySign
      .split('')
      .map((char) => '\\' + char)
      .join('');
    const currencySignString = new RegExp('^' + escapedCurrencySign + '\\s*$');
    const currencySignWithNumberString = new RegExp('^' + escapedCurrencySign + '\\s*\\d+(\\.\\d{0,2})?$');

    if (
      targetValue != currencySign &&
      (currencySignString.test(targetValue) || currencySignWithNumberString.test(targetValue))
    ) {
      const numberValue = targetValue.split(' ')[1];
      if (!Number.isNaN(numberValue) && Number(targetValue.split(' ')[1]) > 0) {
        setValid(true);
        setValue(parseFloat(numberValue));
        setValueString(targetValue);
      } else {
        setValueString(targetValue);
        setValid(false);
      }
    }
  };

  return (
    <div className="currency-input">
      <Input
        className="currency-input__input"
        fullWidth={false}
        type="text"
        name={name}
        value={valueString}
        onChange={handleInputChange}
      />
      <div className="pdq-arrows-wrapper">
        <div
          className="up"
          onClick={() => {
            setValid(true);
            setValue(value + 1);
            setValueString(formatValue(value + 1));
          }}>
          <img src="./assets/icons/arrow.svg" />
        </div>
        <div
          className="down"
          onClick={() => {
            if (minValue !== undefined && value < 1 && value > minValue) {
              value = 1;
            } else if (value < 1) return;

            setValid(true);
            setValue(value - 1);
            setValueString(formatValue(value - 1));
          }}>
          <img src="./assets/icons/arrow.svg" />
        </div>
      </div>
    </div>
  );
};
